<template>
    <div class="p-4 bg-white rounded shadow-sm">
        <div class="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
            <b-button variant="info" @click="prepareAddSection()">
                <i class="fas fa-plus-square text-white"></i> Add Section
            </b-button>
            <b-button variant="danger" size="sm" @click="closeWindow">Close</b-button>
        </div>

       <div v-if="errorMsg" class="position-relative border border-danger rounded p-2 mb-2" style="max-width: 400px;">
            <span @click="errorMsg = null"
                    style="position: absolute; top: 4px; right: 8px; cursor: pointer; font-size: 1.2rem;">
                &times;
            </span>
            <span class="text-danger d-block">
                <strong>{{ errorMsg }}</strong>
            </span>
        </div>

        <br>
        <table class="table table-striped table-bordered">
            <thead class="thead-dark text-left">
                <tr>
                    <th>Order No</th>
                    <th>Section Name</th>
                    <th>Section Type</th>
                    <th>Questions</th>
                    <th>Manage Verifier</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(section, sindex) in admissionformSections" :key="sindex">
                    <td>{{ section.order_no }}</td>
                    <td>{{ section.name }}</td>
                    <td>
                        <span v-if="section.type == 'form'"> Form </span>
                    </td>
                    <td>
                        <a 
                            @click="createAdmissionFormQuestions(section.id)" 
                            class="text-primary font-weight-bold text-decoration-none"
                            style="cursor: pointer;">
                            Create Questions
                        </a>
                    </td>
                    <td>
                        <i @click="$bvModal.show('manageApprovers' + sindex)" class="fas fa-cog text-info ml-2" style="font-size: 15px!important;"></i>
                        <b-modal
                            :id="'manageApprovers' + sindex"
                            :title="'Add/Remove Approvers: ' + section.name"
                            no-close-on-backdrop
                            no-close-on-keyboard
                            no-close-on-esc
                            hide-footer
                            size="lg"
                          >
                            <Approvers :sectionId="section.id" />
                          </b-modal>
                    </td>
                    <td>
                        <i class="fas fa-edit text-info ml-2" style="font-size: 15px!important;cursor: pointer;"
                            @click="editAdmissionFormSection(section)"></i>
                        <i class="fas fa-trash text-danger ml-2" style="font-size: 15px!important;cursor: pointer;"
                            @click="deleteAdmissionFormSection(section)"></i>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Add Section Modal -->
        <b-modal ref="addSectionModal" title="Add Section" no-close-on-backdrop no-close-on-keyboard hide-footer>
            <b-form @submit.prevent="submitSection">
                <!-- Order No -->
                <b-form-group label-cols="12">
                    <label>
                        Order No <span class="text-danger">*</span>
                    </label>
                    <b-form-input id="order-no" type="number" v-model="section.order_no"
                        :class="{ 'form-group-error': $v.section.order_no.$error }"
                        @blur="$v.section.order_no.$touch()" />
                    <span class="input-error-message"
                        v-if="!$v.section.order_no.required && $v.section.order_no.$dirty">
                        Order No is required!
                    </span>
                </b-form-group>

                <!-- Section Name -->
                <b-form-group label-cols="12">
                    <label>
                        Section Name <span class="text-danger">*</span>
                    </label>
                    <b-form-input id="section-name" v-model="section.name"
                        :class="{ 'form-group-error': $v.section.name.$error }" @blur="$v.section.name.$touch()" />
                    <span class="input-error-message" v-if="!$v.section.name.required && $v.section.name.$dirty">
                        Section Name is required!
                    </span>
                </b-form-group>

                <!-- Section Type -->
                <b-form-group label-cols="12">
                    <label>
                        Section Type <span class="text-danger">*</span>
                    </label>
                    <b-form-select id="section-type" v-model="section.type" :options="sectionTypes"
                        :class="{ 'form-group-error': $v.section.type.$error }" @blur="$v.section.type.$touch()" />
                    <span class="input-error-message" v-if="!$v.section.type.required && $v.section.type.$dirty">
                        Section Type is required!
                    </span>
                </b-form-group>

                <!-- Submit and Cancel Buttons -->
                <div class="text-right">
                    <b-button variant="primary" type="submit">Submit</b-button>
                    <b-button variant="danger" class="ml-2" @click="$refs.addSectionModal.hide()">Cancel</b-button>
                </div>
            </b-form>
        </b-modal>

    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import Approvers from "./admissionFormApprovers.vue";

export default {
    name: 'AdmissionFormDashboard',
    data() {
        return {
            errorMsg: '',
            admissionform_id: null,
            admissionformSections: [],
            editMode: false,
            editingSectionId: null,
            section: {
                order_no: '',
                name: '',
                type: 'form',
            },
            sectionTypes: [{ value: 'form', text: 'Form' }],
        };
    },
    components: {
       Approvers
    },
    validations: {
        section: {
            order_no: { required },
            name: { required },
            type: { required },
        },
    },
    async created() {
        this.admissionform_id = this.$route.params.admissionform_id;
        await this.fetchSections();
    },
    methods: {
        createAdmissionFormQuestions(admissionformSectionId) {
            const routeData = this.$router.resolve({
                name: 'AdmissionFormQuestions',
                params: { 
                    admissionform_id: this.admissionform_id,
                    admissionform_section_id: admissionformSectionId
                 },
            });
            window.open(routeData.href, "_blank");
        },
        prepareAddSection() {
            this.editMode = false;
            this.editingSectionId = null;
            this.section = { order_no: '', name: '', type: 'form' };
            this.$v.$reset();
            this.$refs.addSectionModal.show();
        },
        editAdmissionFormSection(section) {
            this.editMode = true;
            this.editingSectionId = section.id;
            this.section = {
                order_no: section.order_no,
                name: section.name,
                type: section.type,
            };
            this.$refs.addSectionModal.show();
        },
        async deleteAdmissionFormSection(section) {
            if (confirm('Are you sure you want to delete this section?')) {
                const url = this.$store.getters.getAPIKey.mainAPI + `/admissionformsections/${section.id}`;
                try {
                    await this.$axios.delete(url);
                    this.$toast.success('Section deleted successfully', {
                        position: 'top',
                        duration: 3000,
                    });
                    await this.fetchSections();
                } catch (error) {
                    console.error("Error deleting section:", error);

                    // Check if error message exists, otherwise show default
                    this.errorMsg = error.response.data.message || 'An error occurred while deleting the section.';
                }
            }
        },
        async fetchSections() {
            const url = this.$store.getters.getAPIKey.mainAPI + `/admissionformsections`;

            try {
                const res = await this.$axios.get(url, {
                    params: {
                        admissionform_id: this.admissionform_id,
                    },
                });
                this.admissionformSections = res.data;
            } catch (err) {
                console.error("Error fetching sections:", err);
            }
        },
        closeWindow() {
            window.close();
        },
        async submitSection() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                const modalBody = this.$refs.addSectionModal.$el.querySelector('.modal-body');
                this.$smoothScroll({
                    container: modalBody,
                    scrollTo: modalBody.querySelector('.form-group-error'),
                    duration: 800,
                    offset: -60,
                });
                return;
            }

            try {
                const payload = {
                    admissionform_id: this.admissionform_id,
                    ...this.section,
                };

                if (this.editMode) {
                    const url = this.$store.getters.getAPIKey.mainAPI + `/admissionformsections/${this.editingSectionId}`;
                    await this.$axios.put(url, payload);
                    this.$toast.success('Section updated successfully', {
                        position: 'top',
                        duration: 3000,
                    });
                } else {
                    const url = this.$store.getters.getAPIKey.mainAPI + `/admissionformsections`;
                    await this.$axios.post(url, payload);
                    this.$toast.success('Section added successfully', {
                        position: 'top',
                        duration: 3000,
                    });
                }

                // Reset
                this.section = { order_no: '', name: '', type: 'form' };
                this.$v.$reset();
                this.editMode = false;
                this.editingSectionId = null;

                this.$refs.addSectionModal.hide();
                await this.fetchSections();

            } catch (error) {
                console.error("Error saving section:", error);
                this.$toast.error(this.editMode ? 'Failed to update section' : 'Failed to add section', {
                    position: 'top',
                    duration: 3000,
                });
            }
        },
    },
};
</script>

<style scoped>
.form-group-error {
    border-color: #dc3545 !important;
}

.input-error-message {
    color: #dc3545;
    font-size: 0.875rem;
}
</style>